import React from "react";
import { Card, Button, Alert, Container, Spinner } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar"
import "../css/profile.css"
import logo from "../imgs/logo24.png"
import { Link } from "react-router-dom"
import * as FaIcons from 'react-icons/fa';

//firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import 'firebase/compat/firestore';
import {
    collection,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
} from "firebase/firestore";

export default function Profile() {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const { currentUser, logout } = useAuth()
    const navigate = useNavigate()

    const [usersData, setUserData] = useState([]);
    const dataCollectionRef = db.collection("admin");

    async function handleLogout() {
        setError("")

        try {
            await logout()
            navigate("/login");
        } catch {
            setError("Failed to log out")
        }
    }

    // get user data
    useEffect(() => {
        const getUsers = async () => {
            setLoading(true);

            const data = await getDocs(dataCollectionRef.where("userID", "==", currentUser.uid));

            setUserData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

            setTimeout(() => {
                setLoading(false)
            }, 1200);
        };

        getUsers();
    }, []);

    return (
        <>
            <Sidebar>
                <div id="alertss"> <h1 className="text-center"> <img src={logo} alt="logo" /> Profile Details <img src={logo} alt="logo" /></h1> {error && <Alert variant="danger">{error}</Alert>} </div>
                <div id="bg-container" className="d-flex align-items-center justify-content-center">
                    <div id="profile-card">
                        {
                            loading ?

                                <div className="loader">
                                    <Spinner animation="grow" variant="primary" />
                                </div>

                                :

                                <Card.Body id="card-body">
                                    <div id="user-details">
                                        <div className="w-100 text-center mt-3">
                                            <Link className="terms-link" to="/termspolicy"><FaIcons.FaAngleLeft /> MentorWayz Application - Terms And Policy <FaIcons.FaAngleRight /> </Link>
                                        </div>

                                        <br />

                                        <span> <strong>Email:</strong> </span>
                                        <p> {currentUser.email} </p>

                                        <span> <strong>Username:</strong> </span>
                                        <br />
                                        {usersData.map((userdata) => (
                                            <span> {userdata.adminName} </span>
                                        ))}

                                        <br />
                                        <br />

                                        <span> <strong>User Type:</strong> </span>
                                        <br />
                                        {usersData.map((userdata) => (
                                            <span> {userdata.userType} </span>
                                        ))}

                                    </div>

                                    <br />

                                    <div id="logout-container">
                                        <Button id="logout-btn" variant="link" onClick={handleLogout}>
                                            Log Out
                                        </Button>
                                    </div>

                                </Card.Body>
                        }

                    </div>
                </div>
            </Sidebar>
        </>
    )
}
